<template>
	<div id="details_carryout" style="padding-bottom: 20px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit">
			<van-field v-model="form.complete_remark" rows="3" autosize label="完成说明" type="textarea"
				placeholder="请输入完成说明" :rules="[
					{
						required: true,
						trigger: 'onBlur',
						message: '请输入完成说明',
					},
				]" />
			<!-- <van-field v-if="this.$route.query.type == 1 && this.$route.query.Code == 1"
				v-model="form.projectCode"
				name="项目编码"
				label="项目编码"
				placeholder="输入项目编码"
				@blur="searchProjectCode"
				@input="onProjectCodeInput"
			/> -->
			<!-- 项目编码联想输入框 -->
			<van-field v-if="this.$route.query.type == 1 && this.$route.query.Code == 1 && this.$route.query.project == 0" v-model="projectCodeInput"
				name="项目编码" label="项目编码" placeholder="输入项目编码" @focus="showProjectList = true"
				@blur="handleProjectCodeBlur" @input="onProjectCodeInput" :readonly="isProjectCodeSelected">
				<template #right-icon>
					<div class="project-code-icons">
						<van-icon v-if="form.projectCode && isProjectCodeSelected" name="clear"
							@click="clearProjectCode" class="clear-icon" />
						<van-loading v-if="searching" size="16px" />
						<van-icon v-else name="arrow-down" @click="toggleProjectList" />
					</div>
				</template>
			</van-field>

			<!-- 项目编码下拉列表 -->
			<div v-if="showProjectList && (filteredProjects.length > 0 || searching)" class="project-dropdown">
				<div v-if="searching" class="project-item">
					<van-loading size="16px" /> 搜索中...
				</div>
				<div v-for="item in filteredProjects" :key="item.code" class="project-item"
					@click="selectProjectCode(item)">
					{{ item.code }}
				</div>
			<div v-if="!searching && filteredProjects.length === 0" class="project-item">
				无匹配结果
			</div>
			</div>

			<!-- 隐藏字段用于提交实际的项目编码 -->
			<input type="hidden" v-model="form.projectCode" />

			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="6" :after-read="onAfterRead" accept="all" />
				</template>
			</van-field>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit"
					:disabled="isProjectCodeRequired && !form.projectCode">提交</van-button>
			</div>
		</van-form>

		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 
import { post } from "@/api/dispatch";

export default {
	name: "carryout_details",
	components: {
		navbar,
	},
	data() {
		return {
			title: "派单完成",
			form: {
				complete_remark: "",
				projectCode: "", // 实际选中的项目编码
				uploader: [],
			},
			projectCodeInput: "", // 用户输入的显示值
			signTime: true,
			// 项目编码相关数据
			allProjects: [], // 所有项目编码数据
			filteredProjects: [], // 过滤后的项目编码
			showProjectList: false,
			searching: false,
			isProjectCodeSelected: false, // 是否已选择项目编码
			searchTimer: null, // 防抖定时器
		};
	},
	computed: {
		// 判断项目编码是否为必填项
		isProjectCodeRequired() {
		return this.$route.query.type == 1 && this.$route.query.Code == 1 && this.$route.query.project == 0;
		}
	},
	mounted() {
		// 页面加载时获取所有项目编码数据
		if (this.isProjectCodeRequired) {
		this.loadAllProjects();
		}
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		
    
    // 加载所有项目编码数据
		loadAllProjects() {
			// 不再需要预加载所有数据，改为按需搜索
			this.allProjects = [];
			this.filteredProjects = [];
		},
		// 搜索项目编码
		async searchProjectCode(search) {
		if (!search || search.length < 1) {
			this.filteredProjects = [];
			return;
		}
		
		this.searching = true;
		try {
			const response = await post({
			requestType: "code_list",
			page: 1,
			limit: 20,
			code: search
			});
			
			if (response.obj && response.obj.rows) {
			this.filteredProjects = response.obj.rows;
			this.showProjectList = response.obj.rows.length > 0;
			} else {
			this.filteredProjects = [];
			this.showProjectList = false;
			}
		} catch (error) {
			console.error('搜索项目编码失败:', error);
			Toast.fail('搜索项目编码失败');
			this.filteredProjects = [];
			this.showProjectList = false;
		} finally {
			this.searching = false;
		}
		},
		// 清空项目编码选择
	clearProjectCode(event) {
		event.stopPropagation(); // 阻止事件冒泡
		this.form.projectCode = "";
		this.projectCodeInput = "";
		this.isProjectCodeSelected = false;
		this.filteredProjects = [...this.allProjects]; // 重置过滤列表
		this.showProjectList = false;
	},
    // 处理项目编码输入
    onProjectCodeInput(value) {
		if (!value) {
			this.filteredProjects = [];
			this.form.projectCode = "";
			this.isProjectCodeSelected = false;
			this.showProjectList = false;
			return;
		}
		// 清除之前的定时器
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
		// 设置新的定时器，实现防抖效果
		this.searchTimer = setTimeout(() => {
			this.searchProjectCode(value);
		}, 800); // 1000ms 防抖延迟
		
		this.showProjectList = true;
    },
    
    // 切换项目列表显示状态
    toggleProjectList() {
		this.showProjectList = !this.showProjectList;
		// 如果显示列表且有输入内容，则重新搜索
		if (this.showProjectList && this.projectCodeInput && this.projectCodeInput.length >= 1) {
			this.searchProjectCode(this.projectCodeInput);
		}
    },
    
    // 处理项目编码输入框失去焦点
    handleProjectCodeBlur() {
      // 延迟隐藏下拉列表，确保点击选项时不会立即隐藏
      setTimeout(() => {
        this.showProjectList = false;
      }, 200);
    },
    
    // 选择项目编码
    selectProjectCode(project) {
		this.form.projectCode = project.code; 
		this.projectCodeInput = project.code; 
		this.isProjectCodeSelected = true;
		this.showProjectList = false;
    },
		onSubmit() {
			// 验证项目编码是否为必填项且已选择
			if (this.isProjectCodeRequired && !this.form.projectCode) {
				Toast.fail('请选择项目编码');
				return;
			}
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("complete_remark", this.form.complete_remark);
			formData.append("projectCode", this.form.projectCode);
			formData.append("order_id", this.$route.query.orderId);
			formData.append("requestType", "open_event");
			formData.append("assign_id", this.$route.query.id);
			formData.append("assign_status", "3");
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						// 通过路由参数传递刷新信号
						this.$route.params.refresh = true;
						Toast.fail("确认成功完成!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
	},
};
</script>

<style lang="scss">
#details_carryout {
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
	.project-dropdown {
    position: absolute;
    z-index: 999;
    width: calc(100% - 30px);
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 0 15px;
  }
  
  .project-item {
    padding: 10px 15px;
    border-bottom: 1px solid #f5f5f5;
    cursor: pointer;
    
    &:hover {
      background-color: #f5f5f5;
    }
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .project-selected {
    background-color: #e6f7ff;
  }
  .project-code-icons {
  display: flex;
  align-items: center;
  
  .clear-icon {
    margin-right: 5px;
  }
}

.project-dropdown {
  position: absolute;
  z-index: 999;
  width: calc(100% - 30px);
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 0 15px;
}

.project-item {
  padding: 10px 15px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
}
}
</style>
